/**
 * Post-login landing route resolver.
 *
 * LR Direct is the DEFAULT product for brokers and shippers, so a fresh login
 * must land them on their LR Direct dashboard (not the LaneRunner load-board
 * dashboard). Carriers are unchanged.
 *
 * Also seeds the ProductContext storage key so the LR Direct context is active
 * on arrival instead of whatever was last persisted.
 */
const CONTEXT_STORAGE_KEY = "lr_active_context";

export function postLoginRoute(userType: string | null | undefined): string {
  switch (userType) {
    case "broker":
    case "broker_carrier":
      seedContext("lr-direct");
      return "/lr-direct/broker";
    case "shipper":
      seedContext("lr-direct");
      return "/shipper-dashboard";
    case "carrier":
      return "/carrier-dashboard";
    default:
      return "/";
  }
}

function seedContext(mode: "lanerunner" | "lr-direct") {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(CONTEXT_STORAGE_KEY, mode);
    }
  } catch {
    /* non-fatal */
  }
}
